// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Edgeworker = function Edgeworker(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M3.775 2.322a1.617 1.617 0 01.231-.29l1.439 2.52-1.562 2.731a1.463 1.463 0 000 1.434l1.562 2.731-1.439 2.52a1.415 1.415 0 01-.231-.295L.828 8.7a1.361 1.361 0 010-1.395zM10.95 14.385H8.883l3.237-5.668a1.463 1.463 0 000-1.434L8.873 1.615h2.077a1.473 1.473 0 011.272.707L15.17 7.3a1.343 1.343 0 010 1.395l-2.947 4.98a1.473 1.473 0 01-1.277.707z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M5.052 14.385h-.1q1.651-2.907 3.31-5.81a1.145 1.145 0 000-1.149l-3.32-5.81h2.77l3.527 6.174a.431.431 0 010 .422L7.7 14.385z"
    }))
  );
};

export default Edgeworker;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Edgeworker.js
// module id = 1001
// module chunks = 0